import React from 'react';
import { CHECKOUT_URL } from '../data/toolkit';
import { PRODUCT_EVENT_PARAMS, trackMetaEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  label: string;
  /** 'scroll' jumps to the final offer section, 'checkout' opens the checkout. */
  action?: 'scroll' | 'checkout';
  variant?: 'navy' | 'teal';
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  action = 'scroll',
  variant = 'navy',
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const palette = variant === 'teal' ? 'bg-teal text-white hover:bg-teal-deep focus-visible:outline-teal-deep' : 'bg-navy text-white hover:bg-navy-deep focus-visible:outline-navy';
  const sizing = size === 'lg' ? 'px-7 py-4 text-[0.95rem]' : 'px-6 py-3.5 text-[0.85rem]';
  const handleScroll = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const target = document.getElementById('offer');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleCheckout = () => {
    trackMetaEvent('InitiateCheckout', PRODUCT_EVENT_PARAMS);
  };
  if (action === 'checkout') {
    return <a href={CHECKOUT_URL} onClick={handleCheckout} className={`inline-flex w-full items-center justify-center gap-2 rounded-full font-semibold uppercase tracking-[0.06em] shadow-card transition-[background-color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-lift focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${palette} ${sizing} ${className}`} data-id="element-28" data-mp="3ey42m2pnd7np">
        {label} <span aria-hidden="true" data-id="element-29" data-mp="1jhhym1x5hj5">→</span>
      </a>;
  }
  return <a href="#offer" onClick={handleScroll} className={`inline-flex w-full items-center justify-center gap-2 rounded-full font-semibold uppercase tracking-[0.06em] shadow-card transition-[background-color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-lift focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${palette} ${sizing} ${className}`} data-id="element-30" data-mp="6iao1tevm69a">
      {label} <span aria-hidden="true" data-id="element-31" data-mp="3i0760z9vcfpk">→</span>
    </a>;
}